import { useMutation } from '@apollo/client'
import { createPage as createPageGql }
   from 'src/graphql/mutations/createPage.gql'

const useCreatePage = (mutationHookOptions) => {
   const [createPage, { called, client, data, error, loading }] =
      useMutation(createPageGql, mutationHookOptions)

   const wrappedMutationFn = (input, mutationFnOptions) => createPage({
      variables: { input },
      ...mutationFnOptions
   })

   return {
      createPage: wrappedMutationFn,
      called,
      client,
      error,
      mutating: loading,
      result: data
   }
}

export default useCreatePage
